// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { DynamicApplicationScanRunTriggerSchema } from '../inputTypeSchemas/DynamicApplicationScanRunTriggerSchema'
import { DynamicApplicationScanRunStatusSchema } from '../inputTypeSchemas/DynamicApplicationScanRunStatusSchema'

/////////////////////////////////////////
// DYNAMIC APPLICATION SCAN RUN SCHEMA
/////////////////////////////////////////

export const DynamicApplicationScanRunSchema = z.object({
  trigger: DynamicApplicationScanRunTriggerSchema,
  status: DynamicApplicationScanRunStatusSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  scannerScanId: z.string(),
  credentialId: z.string().nullable(),
  progressPercent: z.number().nullable(),
  findingsCount: z.number().int().nullable(),
  targetCount: z.number().int().nullable(),
  scanTargets: JsonValueSchema.nullable(),
  error: z.string().nullable(),
  startedAt: z.coerce.date(),
  completedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type DynamicApplicationScanRun = z.infer<typeof DynamicApplicationScanRunSchema>

export default DynamicApplicationScanRunSchema;
